import React from "react";
import "./pocard.css";
import { useNavigate } from "react-router-dom";

const PoCard = ({ title, more, count, view, path }) => {
  const navigate = useNavigate();

  const onClickPoTable = () => {
    navigate(path);
  };
  return (
    <>
      <div className="po-card p-3">
        <div className="d-flex justify-content-between align-items-center">
          <p className="po-card-title">{title}</p>
          <p>{more}</p>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="po-card-count">{count}</h1>
          <a className="po-card-view" style={{ cursor: "pointer" }}>
            {view}
          </a>
        </div>
      </div>
    </>
  );
};

export default PoCard;
